import { createFileRoute } from "@tanstack/react-router";

import type { RouterContextType } from "@/api/permissions/permissions.api";
import { MODULE_KEYS_MAP } from "@/api/permissions/permissions.types";
import { ProcurementOverviewPage } from "@/components/features/Procurement/design/ProcurementOverviewPage";
import { useBreadcrumb } from "@/hooks/useBreadcrumb";
import { authGuardWithPermissions } from "@/utils/authGuard";
import { getRouteIcon } from "@/utils/getRouteIconComponent";

export const Route = createFileRoute("/_authenticated/procurement/overview")({
  component: ProcurementOverviewRoute,
  beforeLoad: async (args) => {
    await authGuardWithPermissions({
      context: args.context as RouterContextType,
      location: args.location as { pathname: string },
    });
  },
});

function ProcurementOverviewRoute() {
  useBreadcrumb([
    {
      title: "Procurement",
      href: "/procurement",
      icon: getRouteIcon(MODULE_KEYS_MAP.procurement),
    },
    { title: "Overview", href: "/procurement/overview" },
  ]);

  return <ProcurementOverviewPage />;
}
